export default __webpack_public_path__ + "static/media/24.04ef4dcf.jpg";